import { Project } from "../basic/project";

export interface NpiChecklist {
    id?: number;
    project: number;
    project_name?: string;
    part_numbers?: string[];
    active?: boolean;
}

export enum NpiChecklistPhaseStatus {
    COMPLETED = "completed",
    IN_PROGRESS = "in_progress",
    PENDING = "pending"
}

export interface NpiChecklistPhase {
    id: number;
    checklist: number;
    name: string;
    start_date: string | null;
    end_date: string | null;
    order: number;
    status: NpiChecklistPhaseStatus;
}

export interface NpiChecklistPartNumber {
    id: number;
    checklist: number;
    part_number: string;
    board: string;
}

export interface NpiChecklistStatusSummary {
    complete: number;
    on_going: number;
    at_risk: number;
    not_applicable: number;
}

export type NpiChecklistProgressSummary = Omit<NpiChecklistStatusSummary, "not_applicable">;

export interface NpiChecklistOverview {
    id: number;
    project: Project;
    oem: string;
    odm: string;
    pcba_rev: string;
    kick_off_date: string | null;
    part_numbers: NpiChecklistPartNumber[];
    phases: NpiChecklistPhase[];
    total_items: number;
    total_items_completed: number;
    total_items_on_going: number;
    total_items_pending: number;
    total_items_not_applied: number;
    items_percent: NpiChecklistStatusSummary;
    progress_percent: NpiChecklistProgressSummary;
}

export enum NpiChecklistItemStatus {
    COMPLETED = "GREEN",
    ON_GOING = "YELLOW",
    AT_RISK = "RED",
    NOT_APPLICABLE = "GRAY"
}

export interface NpiChecklistItem {
    id: number;
    checklist: number;
    item: string;
    description: string;
    owner: string;
    due_date: string | null;
    status: NpiChecklistItemStatus | "";
    days: number | null;
    closed_on: string | null;
    foxconn_comments: string;
    odm_comments: string;
    order: number;
}